export default __webpack_public_path__ + "static/media/navbar-hlr-orange.31c7bc87.svg";